import styled, { css, keyframes } from "styled-components/macro";
import { uiColors } from "../../../common/styles";
import { smallElevationShadow, contentPaddingSides } from "../../../common/styles";
import { TABLET_WIDTH } from "../../../common/pixels";
import FramiInput from "../../common/FramiInput";

export const WideDiv = styled.div`
    width: 100%;
`;

export const slideInFromBottom = keyframes`
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
`;

export const FormInput = styled(FramiInput)`
    margin: 10px 0 !important;

    @media (min-width: ${TABLET_WIDTH}) {
        margin: 10px 5px !important;
    }

    .MuiOutlinedInput-root {
        border-radius: 8px;
    }

    .MuiOutlinedInput-root legend {
        margin-left: ${(props) => (props.$legendMargin ? `${props.$legendMargin}px` : 'unset')};
    }
`;

export const Title = styled.span`
    font-weight: ${(props) => (props.$fontWeight ? `${props.$fontWeight}` : 400)};
    margin-right: ${(props) => (props.$withRightMargin ? '0.4em' : 0)};
    margin-left: ${(props) => (props.$withLeftMargin ? '0.4em' : 0)};
    // border-right: ${(props) => (props.$hasRightIcon ? '2px solid rgba(255,255,255,0.24)' : 'none')};
    // padding-right: ${(props) => (props.$hasRightIcon ? '0.5em' : 'none')};
    text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'unset')};
    flex-grow: 1;


    ${(props) =>
        !props.$sectionTitle &&
        css`
            font-size: ${(props) => (props.$fontSize ? `${props.$fontSize}px` : '20px')};
        `};

    ${(props) =>
        props.$sectionTitle &&
        css`
            font-size: ${(props) => (props.$fontSize ? `${props.$fontSize}px` : '12px')};
            text-transform: uppercase;
            color: ${(props) => props.$darkMode ? uiColors.WHITE : uiColors.PRIMARY_TEXT};
        `};

    ${(props) =>
        !props.$variant && !props.$sectionTitle &&
        css`
            flex-grow: 1;
            color: ${(props) => props.$darkMode ? uiColors.WHITE : uiColors.PRIMARY_TEXT};
        `};
`;


export const Wrapper = styled.div`
    overflow: hidden;
    position: ${(props) => (props.$isMobile ? 'fixed' : 'absolute')};
    bottom: ${(props) => props.$bottomOffset ? `${props.$bottomOffset}px` : '0'};
    width: 100%;
    // height: ${(props) => (props.$isMobile ? '' : '100%')};
    background-color: white;
    color: #58585d;
    //box-shadow: ${smallElevationShadow};
    z-index: 3002;
    //animation: ${slideInFromBottom} 0.5s ease-out;
    // transition: all 0.4s ease;

    // &.content-enter {
    //     opacity: 0;
    //     transform: translateY(100%);
    // }
    // &.content-enter-active {
    //     opacity: 1;
    //     transform: translateY(0%);
    //     transition: all 0.5s ease-out;
    // }
    // &.content-exit {
    //     opacity: 1;
    //     transform: translateX(0%);
    // }
    // &.content-exit-active {
    //     opacity: 0;
    //     transform: translateY(100%);
    //     transition: all 0.5s ease-out;
    }
`;

export const DrawerContentWrapper = styled.div`
    max-height: ${(props) => props.$height};
    min-height: ${(props) => props.$fixed ? props.$height : ''};
    height: ${(props) => props.$fullDrawer};
    overflow: auto;
    width: 100%;
    padding: ${(props) => props.$isSmall ? '0px 10px' : `0px ${contentPaddingSides}`};
    //margin-bottom: ${contentPaddingSides};

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const DrawerResultsWrapper = styled.section`
    // margin-top: ${(props) => props.$templateDrawer ? props.$isSmall ? '75px' : '105px' : ''};
    margin-top: 12px;
    padding-bottom: 8px;

    ${(props) =>
        !props.$templateDrawer &&
        css`
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: ${(props) => props.$videoDrawer ? 'space-around' : (props.$isMobile ? 'center' : 'unset')};
        `};
`;

export const TemplatesResultWrapper = styled.section`
    flex-direction: column;
    display: flex;
    gap: 4px;
    z-index: 1;
    height: ${(props) => props.$isMobile ? 'auto' : '100%'};
`;

export const TemplateWrapper = styled.section`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const DrawerInputWrapper = styled.label`
    align-self:center;
    margin: 8px 0;
    display: flex;
    border-radius: 8px;
    align-items: center;
    height: 38px;
    flex-grow: 1;
    outline: ${(props) => (props.$disabled ? `1px solid ${uiColors.DISABLED_BORDER}` : `1px solid ${uiColors.ACTIVE_BORDER}`)};

    &:focus-within {
        outline: 1px solid ${uiColors.PRIMARY_300};
    }

    &::before {
        content: '';
        position: absolute;
        left: -26px;
        height: 24px;
        width: 24px;
        transition: fill 0.2s ease-in-out;
    }

    & > svg {
        height: 25px;
        width: 25px;
        fill: ${(props) => (props.$disabled ? uiColors.DISABLED_BORDER : uiColors.ACTIVE_BORDER)}; 
    }

    &:focus-within > svg {
        fill: ${uiColors.PRIMARY_500};
    }

    &:focus-within > span {
        color: ${uiColors.PRIMARY_500};
    }

    &:focus-within::before {
        fill: ${uiColors.PRIMARY_200};
    }

    ${(props) =>
        props.$left &&
        css`
            padding-left: 10px;
            &:focus-within > input {
                border-left: 1px solid ${uiColors.PRIMARY_200};
            }
        `};

    ${(props) =>
        props.$right &&
        css`
            padding-right: 10px;
            &:focus-within > input {
                border-right: 1px solid ${uiColors.PRIMARY_200};
            }
        `};
`;


export const DrawerInput = styled.input`
    background: transparent;
    outline: none;
    height: 100%;
    width: 100%;
    margin-right: 8px;
    text-align: center;
    color: ${(props) => (props.disabled ? uiColors.DISABLED_BORDER : uiColors.ACTIVE_BORDER)};

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    ::placeholder {
        font-style: italic;
        color: ${(props) => (props.disabled ? uiColors.DISABLED_BORDER : uiColors.ACTIVE_BORDER)};
    }

    ${(props) =>
        props.$left &&
        css`
            margin-left: 10px;
            border-left: 1px solid ${props.disabled ? uiColors.DISABLED_BORDER : uiColors.ACTIVE_BORDER};
        `};

    ${(props) =>
        props.$right &&
        css`
            margin-right: 10px;
            border-right: 1px solid ${props.disabled ? uiColors.DISABLED_BORDER : uiColors.ACTIVE_BORDER};
        `};
    
    -moz-appearance: textfield;
`;

export const DrawerTextarea = styled.textarea`
    outline: none;
    height: 100%;
    width: 98%;
    margin: 8px 8px 0;
    padding-right: 8px;
    text-align: left;
    resize: none;
`;

export const SectionWrapper = styled.section`
    margin-top: 5px;
`;

export const SectionTitle = styled.p`
    font-size: 14px;
    color: ${(props) => (props.$opacity ? uiColors.GRAY_400 : uiColors.PRIMARY_TEXT)};
    font-weight: 400;
    align-items: center;
    margin: 8px 0 4px 0;
    padding: 0;
    opacity: ${(props) => (props.$opacity ? 0.7 : 1)};
`;

export const CounterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-right: 8px;
`;

export const Counter = styled.span`
  color: ${(props) => (props.$exceeded === 'true' ? 'red' : uiColors.GRAY_400)};
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    padding: 16px 0;
`;
